export default "__VITE_ASSET__Cohaj6H6__"